import { render, staticRenderFns } from "./SettingsNavbar.vue?vue&type=template&id=ee77a11c&scoped=true&"
import script from "./SettingsNavbar.vue?vue&type=script&lang=ts&"
export * from "./SettingsNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsNavbar.vue?vue&type=style&index=0&id=ee77a11c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee77a11c",
  null
  
)

export default component.exports